const gigsReducerDefaultState = {
  gigs: [],
  gigsLength: 0,
  confirmGigApplyDialogOpen: false,
  gigDetails: null,
  confirmSocialIntegrationDialogOpen: false,
}

export default (state = gigsReducerDefaultState, action) => {
  switch (action.type) {
    case "GIG::SET_GIGS":
      return {
        ...state,
        gigs: action.data,
      }
    case "GIG::TOGGLE_GIG_DIALOG":
      return {
        ...state,
        gigDetails: action.data,
      }
    case "GIG::TOGGLE_CONFIRM_GIG_APPLY_DIALOG":
      return {
        ...state,
        confirmGigApplyDialogOpen: action.data,
      }
    case "GIG::TOGGLE_CONFIRM_SOCIAL_INTEGRATION_DIALOG":
      return {
        ...state,
        confirmSocialIntegrationDialogOpen: action.data,
      }
    default:
      return state
  }
}
